// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slide-item {
  height: 100%;
  cursor: pointer;
}
.slide-item img {
  height: 100%;
  object-fit: cover;
  width: 320px;
}
@media (max-width: 992px) {
  .slide-item img {
    width: 100%;
  }
}
.slide-item.active {
  box-shadow: 0 0 12px rgba(255, 255, 255, 0.8);
  border-radius: 6px;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/SlideMediaItem/SlideMediaItem.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,eAAA;AADJ;AAEI;EACI,YAAA;EACA,iBAAA;EACA,YAAA;AAAR;AAEQ;EALJ;IAMQ,WAAA;EACV;AACF;AACI;EACI,6CAAA;EACA,kBAAA;AACR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
